import { SearchCircleLayer } from './SearchCircleLayer.js';

export class CircleSearch {
    constructor(mapAdapter, map, mediator) {
        this.mapAdapter = mapAdapter;
        this.map = map;
        this.mediator = mediator;

        this.active = false;
        this.isDragging = false;
        this.eventListeners = [];
        this._leftClickMode = false;   // an: auch plain Linksklick zieht den Suchkreis (Touch/keine rechte Maustaste)

        this.circle = null;        // google.maps.Circle — Geometrie-Wahrheit (auch für Konsumenten außerhalb)
        this.circleLayer = null;   // zeichnet ihn; s. SearchCircleLayer (Googles eigene Darstellung liegt zu tief)
        this.circleCenter = null;
        this.circleRadius = null;

        this.setActive(true);
    }

    _initListeners() {
        // MouseDown, MouseMove, MouseUp usw registrieren
        this.eventListeners.push(
            this.mapAdapter.addListener(this.map, 'mousedown', (ev) => this._onMouseDown(ev)),
            this.mapAdapter.addListener(this.map, 'mousemove', (ev) => this._onMouseMove(ev)),
            this.mapAdapter.addListener(this.map, 'mouseup', (ev) => this._onMouseUp(ev))
        );
    }

    setLeftClickMode(enabled = true) {
        this._leftClickMode = !!enabled;
    }

    _onMouseDown(ev) {
        // Rechtsklick (buttons 2) ODER Ctrl+Linksklick — und im Linksklick-Modus zusätzlich plain Linksklick (buttons 1).
        if ((ev.domEvent.ctrlKey && ev.domEvent.buttons === 1) || ev.domEvent.buttons === 2
            || (this._leftClickMode && ev.domEvent.buttons === 1)) {
            console.debug(`CircleSearch: MouseDown with Ctrl/Right-Click`);
            console.debug(this.circle);
            this.circleCenter = ev.latLng;
            this.map.setOptions({draggable: false});
            this.isDragging = true;
        }
    }

    _onMouseMove(ev) {
        if(this.isDragging) {
            if(!this.circleCenter) {
                this.circleCenter = ev.latLng;
            }
            this.circleRadius = this.mapAdapter.getDistance(this.circleCenter, ev.latLng);
            this.circle.setCenter(this.circleCenter);
            this.circle.setRadius(this.circleRadius);
        }
    }

    _onMouseUp(ev) {
        if(this.isDragging) {
            console.debug(`CircleSearch: MouseUp`);
            console.debug(this.circle);
            if(ev.latLng.equals(this.circleCenter)) {
                this.circleCenter = null;
                this.circleRadius = null;
                this.circle.setCenter(null);
                this.circle.setRadius(null);
            }
            this.mediator.publish("circlesearch:trigger", {
                center: this.circleCenter,
                radius: this.circleRadius
            });
            this.isDragging = false;
            this.map.setOptions({draggable: true});
        }
    }

    getCircle() {
        return this.circle;
    }

    // Der Kreis bleibt ein google.maps.Circle (Geometrie: getCenter/getRadius/getBounds nutzen auch MapController und
    // GoogleMapsAdapter), wird aber NICHT von Google gezeichnet: dessen Vektor-Fläche liegt unter den flachen
    // Bild-Overlays und lässt sich per API nicht darüber heben. Das Zeichnen macht der SearchCircleLayer.
    createCircle() {
        this.circle = this.mapAdapter.createCircle({
            fillColor: '#c356a0',
            strokeColor: '#c356a0',
            map: this.map,
            clickable: false
        });
        this.circleLayer = new SearchCircleLayer(this.map, this.circle);
    }

    setCircle(center, radius) {
        this.circle.setCenter(center);
        this.circle.setRadius(radius);
        this.circleCenter = center;
        this.circleRadius = radius;
    }

    deleteCircle(){
        if(this.circle) {
            this.circleCenter = null;
            this.circleRadius = null;
            this.circle.setCenter(null);
            this.circle.setRadius(null);
        }
    }

    setActive(activeState = true) {
        if(activeState === this.active) { return; }
        if(activeState) {
            this.createCircle();
            this._initListeners();
        } else {
            if(this.circleLayer) { this.circleLayer.destroy(); this.circleLayer = null; }
            if(this.circle) { this.circle.setMap(null); }
            this._removeListeners();
        }
        this.active = activeState;
    }

    _removeListeners() {
        for(const listener of this.eventListeners){
            this.mapAdapter.removeListener(listener);
        }
        this.eventListeners = [];
    }
}